/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  SET_INACTIVE: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.userList.setInActive',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'SET_INACTIVE' },
      },
    },
    SET_INACTIVE: {
      invoke: {
        id: 'setInActive',
        src: 'setInActive',
        onDone: {
          target: 'SET_INACTIVE_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'SET_INACTIVE_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SET_INACTIVE_SUCCESS: {
      on: {
        START: { target: 'SET_INACTIVE' },
      },
    },
    SET_INACTIVE_FAILED: {
      on: {
        START: { target: 'SET_INACTIVE' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
